import { getMessage } from '@gef-ui/localization/messages';
import { useStreamContext } from '../../../stream/context';
import { resolveFieldLabel } from '../../../utils/fieldLabel';
/**
 * Provides localized field name
 *
 * @documented
 * @category Field
 * @import import useLocalizedFieldName from '@gef-ui/form-core/hooks/field/useLocalizedFieldName'
 * @param {Object} input
 * @param {String} input.fieldName
 * @returns {String} localizedName
 * @example
 *
 * 	const label = useLocalizedFieldName({fieldName: 'xxx'});
 *
 */ const useLocalizedFieldName = ({ fieldName })=>{
    const { formDescriptor } = useStreamContext();
    const resolvedLabel = resolveFieldLabel(formDescriptor[fieldName]);
    if (resolvedLabel) {
        return resolvedLabel;
    }
    return getMessage(fieldName);
};
export default useLocalizedFieldName;
